.plot-title-style-panel {
  display: flex;
  flex-direction: column;

  grid-column: 1 / 4;
  width: 100%;
  max-width: var(--text-breakout-max-width);

  &:hover {
    background: var(--color-gray-100);
  }
}

.expandable-panel-header {
  display: flex;
  height: 36px;
  align-items: center;

  font-family: var(--font-stack-mono);
  color: inherit;
  font-weight: 600;
  font-size: 0.9rem;

  text-transform: capitalize;
  padding: 0;
  cursor: pointer;

  border: 0;
  background: transparent;
}

.expandable-panel {
  margin: 6px;
  overflow: hidden;
}

.label {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-gap: 0.4rem;
  gap: 0.4rem;
  align-items: center;

  &.beta {
    grid-template-columns: auto auto minmax(0, 1fr);
  }
}

.tag {
  padding: 0.2rem 0.5rem;
  border-radius: 999rem;
  font-family: var(--font-stack);
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.2px;

  background: var(--color-accent-1-500);
  color: var(--text-color-primary-50);

  &.blue {
    background: var(--color-accent-2-500);
  }

  &.darkblue {
    background: var(--color-primary-500);
    color: var(--text-color-primary-500);
  }
}
